import { graphql } from "@/graphql/codegen"

graphql(`
  mutation RemoveInvoiceFromPayFile($input: RemoveInvoiceFromPayFileInput!) {
    payFile {
      removeInvoice(input: $input) {
        __typename
        ... on RemoveInvoiceFromPayFileSuccess {
          payFile {
            payFileId
          }
        }
        ... on RemoveInvoiceFromPayFileFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
